import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'hrms-fieldforce';
  router: any;
  showNavbar: any;
  auth: any;

  constructor(public activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    // Update navbar on route changes
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe(() => {
        const deepest = this.getDeepestChild(this.activatedRoute);
        const hide = deepest.snapshot.data?.['hideNavbar'] === true;
        this.showNavbar = this.auth.isAuthenticated() && !hide;
      });

    // Initial evaluate
    const hide =
      this.activatedRoute.firstChild?.snapshot.data?.['hideNavbar'] === true;
    this.showNavbar = this.auth.isAuthenticated() && !hide;

    // Cross-tab sync: when token changes in another tab, react here
    window.addEventListener('storage', (e) => {
      if (e.key === 'authenticationToken') {
        const loggedIn = this.auth.isAuthenticated();
        const onLoginPage =
          this.router.url.startsWith('/login') || this.router.url === '/';
        if (loggedIn && onLoginPage) this.router.navigateByUrl('/home');
        if (!loggedIn && !onLoginPage) this.router.navigateByUrl('/login');
        // Recompute navbar
        const deepest = this.getDeepestChild(this.activatedRoute);
        const hide = deepest.snapshot.data?.['hideNavbar'] === true;
        this.showNavbar = loggedIn && !hide;
      }
    });
  }

  private getDeepestChild(r: ActivatedRoute): ActivatedRoute {
    while (r.firstChild) r = r.firstChild;
    return r;
  }
}
